import { Switch, Typography } from '@mui/material';
import axios from 'axios';
import React, { useContext, useEffect } from 'react';
import { DashboardContext } from '../../../contexts/dashboard.context';

function ToggleChat() {
	const { socket } = useContext(DashboardContext);

	const [enabled, setEnabled] = React.useState(true);

	useEffect(() => {
		let isMounted = true;
	
		if (socket) {
			axios.post('/api/owner/chat/get').then(({ data }) => {
				if (isMounted) {
					setEnabled(data.chatEnabled === 1);
				}
			});
	
			socket.on('enableChat', () => {
				if (isMounted) {
					setEnabled(true);
				}
			});
	
			socket.on('disableChat', () => {
				if (isMounted) {
					setEnabled(false);
				}
			});
	
			return () => {
				isMounted = false;
				socket.off('enableChat');
				socket.off('disableChat');
			};
		}
	}, [socket]);

	const handleToggle = () => {
		axios.post('/api/owner/chat/toggle');
		setEnabled((e) => !e);
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<Switch checked={enabled} onChange={handleToggle} color='primary' />
			<Typography component={'span'} color='textSecondary'>
				Abilita chat
			</Typography>
		</div>
	);
}

export default ToggleChat;
